"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListingActivityDtoListingTypeEnum = exports.ListingActivityDtoListingStatusEnum = exports.ListingActivityDtoAuctionStatusEnum = exports.ListingActivityDtoCampaignEnum = void 0;
exports.instanceOfListingActivityDto = instanceOfListingActivityDto;
exports.ListingActivityDtoFromJSON = ListingActivityDtoFromJSON;
exports.ListingActivityDtoFromJSONTyped = ListingActivityDtoFromJSONTyped;
exports.ListingActivityDtoToJSON = ListingActivityDtoToJSON;
exports.ListingActivityDtoToJSONTyped = ListingActivityDtoToJSONTyped;
var ListingActivityLogDto_1 = require("./ListingActivityLogDto");
var AuctionSummaryDto_1 = require("./AuctionSummaryDto");
var BidderDto_1 = require("./BidderDto");
var BidActivityDto_1 = require("./BidActivityDto");
/**
 * @export
 */
exports.ListingActivityDtoCampaignEnum = {
    VendorManaged: 'vendor_managed',
    UnreservedManaged: 'unreserved_managed'
};
/**
 * @export
 */
exports.ListingActivityDtoAuctionStatusEnum = {
    ToBeStarted: 'to_be_started',
    InProgress: 'in_progress',
    Paused: 'paused',
    Completed: 'completed',
    Cancelled: 'cancelled'
};
/**
 * @export
 */
exports.ListingActivityDtoListingStatusEnum = {
    Draft: 'draft',
    Active: 'active',
    UnderOffer: 'under_offer',
    OffTheMarket: 'off_the_market',
    PassedIn: 'passed_in',
    Disabled: 'disabled',
    Deleted: 'deleted',
    Sold: 'sold'
};
/**
 * @export
 */
exports.ListingActivityDtoListingTypeEnum = {
    PrivateSale: 'private_sale',
    Auction: 'auction',
    ReverseAuction: 'reverse_auction'
};
/**
 * Check if a given object implements the ListingActivityDto interface.
 */
function instanceOfListingActivityDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('campaign' in value) || value['campaign'] === undefined)
        return false;
    if (!('price' in value) || value['price'] === undefined)
        return false;
    if (!('totalBids' in value) || value['totalBids'] === undefined)
        return false;
    if (!('totalBidders' in value) || value['totalBidders'] === undefined)
        return false;
    if (!('listingStatus' in value) || value['listingStatus'] === undefined)
        return false;
    if (!('listingType' in value) || value['listingType'] === undefined)
        return false;
    if (!('listingTitle' in value) || value['listingTitle'] === undefined)
        return false;
    if (!('listingLocation' in value) || value['listingLocation'] === undefined)
        return false;
    if (!('offersAllowed' in value) || value['offersAllowed'] === undefined)
        return false;
    return true;
}
function ListingActivityDtoFromJSON(json) {
    return ListingActivityDtoFromJSONTyped(json, false);
}
function ListingActivityDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'campaign': json['campaign'],
        'price': json['price'],
        'reservePrice': json['reservePrice'] == null ? undefined : json['reservePrice'],
        'auctionStartPrice': json['auctionStartPrice'] == null ? undefined : json['auctionStartPrice'],
        'auctionScheduledEndAt': json['auctionScheduledEndAt'] == null ? undefined : json['auctionScheduledEndAt'],
        'auctionNextPriceDropAt': json['auctionNextPriceDropAt'] == null ? undefined : json['auctionNextPriceDropAt'],
        'auctionCancellationReason': json['auctionCancellationReason'] == null ? undefined : json['auctionCancellationReason'],
        'totalBids': json['totalBids'],
        'listingActivityLogs': json['listingActivityLogs'] == null ? undefined : (json['listingActivityLogs'].map(ListingActivityLogDto_1.ListingActivityLogDtoFromJSON)),
        'totalBidders': json['totalBidders'],
        'bidIncrement': json['bidIncrement'] == null ? undefined : json['bidIncrement'],
        'totalPriceDrops': json['totalPriceDrops'] == null ? undefined : json['totalPriceDrops'],
        'auctionStartDate': json['auctionStartDate'] == null ? undefined : json['auctionStartDate'],
        'pausedAt': json['pausedAt'] == null ? undefined : json['pausedAt'],
        'resumedAt': json['resumedAt'] == null ? undefined : json['resumedAt'],
        'auctionStatus': json['auctionStatus'] == null ? undefined : json['auctionStatus'],
        'listingStatus': json['listingStatus'],
        'listingType': json['listingType'],
        'summary': json['summary'] == null ? undefined : (0, AuctionSummaryDto_1.AuctionSummaryDtoFromJSON)(json['summary']),
        'bids': json['bids'] == null ? undefined : (json['bids'].map(BidActivityDto_1.BidActivityDtoFromJSON)),
        'listingTitle': json['listingTitle'],
        'listingImage': json['listingImage'] == null ? undefined : json['listingImage'],
        'listingLocation': json['listingLocation'],
        'bidder': json['bidder'] == null ? undefined : (0, BidderDto_1.BidderDtoFromJSON)(json['bidder']),
        'offersAllowed': json['offersAllowed'],
        'reverseAuctionDecreaseAmount': json['reverseAuctionDecreaseAmount'] == null ? undefined : json['reverseAuctionDecreaseAmount'],
        'auctionIncreaseIntervalMinutes': json['auctionIncreaseIntervalMinutes'] == null ? undefined : json['auctionIncreaseIntervalMinutes'],
        'reverseAuctionDecreaseIntervalMinutes': json['reverseAuctionDecreaseIntervalMinutes'] == null ? undefined : json['reverseAuctionDecreaseIntervalMinutes'],
    };
}
function ListingActivityDtoToJSON(json) {
    return ListingActivityDtoToJSONTyped(json, false);
}
function ListingActivityDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'campaign': value['campaign'],
        'price': value['price'],
        'reservePrice': value['reservePrice'],
        'auctionStartPrice': value['auctionStartPrice'],
        'auctionScheduledEndAt': value['auctionScheduledEndAt'],
        'auctionNextPriceDropAt': value['auctionNextPriceDropAt'],
        'auctionCancellationReason': value['auctionCancellationReason'],
        'totalBids': value['totalBids'],
        'listingActivityLogs': value['listingActivityLogs'] == null ? undefined : (value['listingActivityLogs'].map(ListingActivityLogDto_1.ListingActivityLogDtoToJSON)),
        'totalBidders': value['totalBidders'],
        'bidIncrement': value['bidIncrement'],
        'totalPriceDrops': value['totalPriceDrops'],
        'auctionStartDate': value['auctionStartDate'],
        'pausedAt': value['pausedAt'],
        'resumedAt': value['resumedAt'],
        'auctionStatus': value['auctionStatus'],
        'listingStatus': value['listingStatus'],
        'listingType': value['listingType'],
        'summary': (0, AuctionSummaryDto_1.AuctionSummaryDtoToJSON)(value['summary']),
        'bids': value['bids'] == null ? undefined : (value['bids'].map(BidActivityDto_1.BidActivityDtoToJSON)),
        'listingTitle': value['listingTitle'],
        'listingImage': value['listingImage'],
        'listingLocation': value['listingLocation'],
        'bidder': (0, BidderDto_1.BidderDtoToJSON)(value['bidder']),
        'offersAllowed': value['offersAllowed'],
        'reverseAuctionDecreaseAmount': value['reverseAuctionDecreaseAmount'],
        'auctionIncreaseIntervalMinutes': value['auctionIncreaseIntervalMinutes'],
        'reverseAuctionDecreaseIntervalMinutes': value['reverseAuctionDecreaseIntervalMinutes'],
    };
}
